/* ============================================================
 * Karl Kaplan – Bundle Deals (Kaching-style)
 * <bundle-deals> custom element.
 *  - mode="volume": quantity-break tiers for the current product,
 *    with a per-item Farbe/Größe picker for each piece in the set.
 *  - mode="mix": fixed set of products ("frequently bought together")
 * Adds to the theme's AJAX cart (cart-drawer / cart-notification)
 * and auto-applies the matching discount code per selection.
 * ============================================================ */
(function () {
  if (window.customElements.get('bundle-deals')) return;

  var LOCALE = 'de-DE';
  var CURRENCY = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';

  function money(cents) {
    var v = (Number(cents) || 0) / 100;
    try {
      return v.toLocaleString(LOCALE, { style: 'currency', currency: CURRENCY });
    } catch (e) {
      return v.toFixed(2).replace('.', ',') + ' €';
    }
  }

  function parseJSON(el, fallback) {
    if (!el) return fallback;
    try { return JSON.parse(el.textContent); } catch (e) { return fallback; }
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  class BundleDeals extends HTMLElement {
    connectedCallback() {
      this.mode = this.getAttribute('data-mode') || 'volume';
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.button = this.querySelector('.kkb__button');
      this.errorEl = this.querySelector('.kkb__error');
      this.info = this.closest('[id^="MainProduct-"]') || document;

      if (this.button) this.button.addEventListener('click', this.onAdd.bind(this));

      if (this.mode === 'volume') this.initVolume();
      else this.initMix();

      // Hide the theme's default add-to-cart button so this widget is the single CTA.
      this.hideDefaultButton();
    }

    hideDefaultButton() {
      var def = this.info.querySelector('product-form .product-form__buttons');
      if (def) def.style.display = 'none';
      // When the widget owns variant selection, hide the theme's native variant picker
      // so Farbe/Größe are chosen per piece inside the widget instead.
      if (this.mode === 'volume' && this.ownVariants) {
        this.info.querySelectorAll('variant-radios, variant-selects').forEach(function (el) {
          el.style.display = 'none';
        });
      }
    }

    /* ---------- VOLUME ---------- */
    initVolume() {
      this.product = parseJSON(this.querySelector('[data-kkb-product]'), { options: [], variants: [] });
      this.ownVariants = this.getAttribute('data-own-variants') === 'true' && this.product.variants.length > 0;
      this.itemsWrap = this.querySelector('.kkb__items');
      this.gallery = this.info.querySelector('media-gallery');
      this.tiers = Array.prototype.slice.call(this.querySelectorAll('.kkb__tier'));
      this.selected = null;
      this.defaultOptions = this.initialOptions();

      this.tiers.forEach(function (tier) {
        tier.addEventListener('click', function () { this.selectTier(tier); }.bind(this));
      }.bind(this));

      var def = this.querySelector('.kkb__tier[data-default="true"]') || this.tiers[0];
      if (def) this.selectTier(def);
    }

    initialOptions() {
      var sel = null;
      var input = this.info.querySelector('product-form [name="id"]');
      if (input && input.value) sel = this.findVariantById(Number(input.value));
      if (!sel) sel = this.product.variants.filter(function (v) { return v.available; })[0] || this.product.variants[0];
      return sel ? sel.options.slice() : [];
    }

    findVariantById(id) {
      return this.product.variants.filter(function (v) { return v.id === id; })[0];
    }

    variantForOptions(opts) {
      return this.product.variants.filter(function (v) {
        return v.options.length === opts.length && v.options.every(function (o, i) { return o === opts[i]; });
      })[0];
    }

    currentQty() {
      return parseInt((this.selected && this.selected.getAttribute('data-qty')) || '1', 10) || 1;
    }

    selectTier(tier) {
      this.tiers.forEach(function (t) {
        t.classList.toggle('is-selected', t === tier);
        var r = t.querySelector('input[type="radio"]');
        if (r) r.checked = (t === tier);
      });
      this.selected = tier;
      if (this.ownVariants) this.renderItems();
      this.refresh();
    }

    /* ----- per-item variant pickers ----- */
    renderItems() {
      if (!this.itemsWrap) return;
      var qty = this.currentQty();
      var prev = this.readItemSelections();
      var html = '';
      for (var n = 0; n < qty; n++) {
        var chosen = prev[n] || this.defaultOptions;
        html += this.itemRowHTML(n, chosen, qty);
      }
      this.itemsWrap.innerHTML = html;
      var self = this;
      this.itemsWrap.querySelectorAll('select').forEach(function (sel) {
        sel.addEventListener('change', function () { self.onItemChange(sel); });
      });
      this.updateAvailability();
    }

    itemRowHTML(index, chosenOpts, qty) {
      var opts = this.product.options || [];
      var selects = '';
      for (var oi = 0; oi < opts.length; oi++) {
        var o = opts[oi];
        var chosen = chosenOpts[oi];
        var optionsHTML = o.values.map(function (val) {
          return '<option value="' + escapeHtml(val) + '"' + (val === chosen ? ' selected' : '') + '>' + escapeHtml(val) + '</option>';
        }).join('');
        selects += '<label class="kkb__field"><span class="kkb__field-label">' + escapeHtml(o.name) + '</span>'
          + '<select class="kkb__select" data-opt-index="' + oi + '">' + optionsHTML + '</select></label>';
      }
      var head = qty > 1 ? '<p class="kkb__item-head">Teil ' + (index + 1) + '</p>' : '';
      return '<div class="kkb__item-row" data-item="' + index + '">' + head
        + '<div class="kkb__item-selects">' + selects + '</div>'
        + '<p class="kkb__item-note" hidden></p></div>';
    }

    readItemSelections() {
      if (!this.itemsWrap) return [];
      return Array.prototype.map.call(this.itemsWrap.querySelectorAll('.kkb__item-row'), function (row) {
        return Array.prototype.map.call(row.querySelectorAll('select'), function (s) { return s.value; });
      });
    }

    onItemChange(sel) {
      this.updateAvailability();
      this.refresh();
      if (sel) {
        var row = sel.closest('.kkb__item-row');
        if (row) {
          var opts = Array.prototype.map.call(row.querySelectorAll('select'), function (s) { return s.value; });
          var v = this.variantForOptions(opts);
          if (v && v.media) this.showMedia(v.media);
        }
      }
    }

    // Switch the theme's media gallery to the chosen variant's image so the
    // customer sees the colour they picked (we hide the native variant picker).
    showMedia(mediaId) {
      if (!mediaId || !this.gallery || !this.gallery.setActiveMedia) return;
      var target = String(mediaId);
      var items = this.gallery.querySelectorAll('[data-media-id]');
      for (var i = 0; i < items.length; i++) {
        var dm = items[i].getAttribute('data-media-id');
        if (dm === target || dm.slice(-(target.length + 1)) === '-' + target) {
          try { this.gallery.setActiveMedia(dm, true); } catch (e) {}
          return;
        }
      }
    }

    // Grey out option values that can't form an available variant with the row's other picks.
    updateAvailability() {
      if (!this.itemsWrap) return;
      var self = this;
      this.itemsWrap.querySelectorAll('.kkb__item-row').forEach(function (row) {
        var selects = Array.prototype.slice.call(row.querySelectorAll('select'));
        var current = selects.map(function (s) { return s.value; });
        selects.forEach(function (sel, si) {
          Array.prototype.forEach.call(sel.options, function (opt) {
            var trial = current.slice();
            trial[si] = opt.value;
            var v = self.variantForOptions(trial);
            opt.disabled = !(v && v.available);
          });
        });
        var v = self.variantForOptions(current);
        var note = row.querySelector('.kkb__item-note');
        if (note) {
          if (!v || !v.available) { note.textContent = 'Diese Kombination ist leider nicht verfügbar.'; note.hidden = false; }
          else { note.hidden = true; }
        }
      });
    }

    resolvedItems() {
      var rows = this.readItemSelections();
      var map = {}; var order = []; var ok = rows.length > 0; var sum = 0;
      var self = this;
      rows.forEach(function (opts) {
        var v = self.variantForOptions(opts);
        if (!v || !v.available) { ok = false; return; }
        if (map[v.id] === undefined) { map[v.id] = 0; order.push(v.id); }
        map[v.id] += 1;
        sum += v.price;
      });
      var items = order.map(function (id) { return { id: Number(id), quantity: map[id] }; });
      return { items: items, ok: ok, sum: sum };
    }

    representativeUnit() {
      if (this.ownVariants) {
        var first = this.readItemSelections()[0];
        if (first) { var v = this.variantForOptions(first); if (v) return v.price; }
        var d = this.variantForOptions(this.defaultOptions); if (d) return d.price;
      }
      return Number(this.getAttribute('data-price')) || 0;
    }

    refresh() {
      if (this.mode !== 'volume') return;
      var qty = this.currentQty();
      var pct = parseFloat(this.selected && this.selected.getAttribute('data-discount')) || 0;
      var unit = this.representativeUnit();
      var showUnit = this.getAttribute('data-show-unit') === 'true';

      // tier list price previews
      this.tiers.forEach(function (tier) {
        var tq = parseInt(tier.getAttribute('data-qty'), 10) || 1;
        var tp = parseFloat(tier.getAttribute('data-discount')) || 0;
        var gross = unit * tq;
        var net = Math.round(gross * (1 - tp / 100));
        var priceEl = tier.querySelector('.kkb__tier-price');
        var cmpEl = tier.querySelector('.kkb__tier-compare');
        if (priceEl) priceEl.textContent = money(net);
        if (cmpEl) cmpEl.textContent = tp > 0 ? money(gross) : '';
        var unitEl = tier.querySelector('.kkb__tier-unit');
        if (unitEl) unitEl.textContent = (showUnit && tq > 1) ? (money(Math.round(net / tq)) + ' / Stück') : '';
      });

      // CTA total from the actually-selected items
      var res = this.ownVariants ? this.resolvedItems() : null;
      var gross = res ? res.sum : unit * qty;
      var net = Math.round(gross * (1 - pct / 100));
      var saved = gross - net;
      var noteEl = this.querySelector('.kkb__cta-note');
      if (noteEl && this.getAttribute('data-show-savings') === 'true') {
        noteEl.innerHTML = saved > 0
          ? 'Gesamt: <strong>' + money(net) + '</strong> · <span class="kkb__cta-savings">Du sparst ' + money(saved) + '</span>'
          : 'Gesamt: <strong>' + money(net) + '</strong>';
      }
      if (this.button) this.button.disabled = !!(this.ownVariants && res && !res.ok);
    }

    /* ---------- MIX & MATCH ---------- */
    initMix() {
      // nothing dynamic to wire; data lives on the element
    }

    /* ---------- ADD TO CART ---------- */
    getItems() {
      if (this.mode === 'volume') {
        if (this.ownVariants) {
          var res = this.resolvedItems();
          return { items: res.items, code: (this.selected && this.selected.getAttribute('data-code')) || '', ok: res.ok };
        }
        var input = this.info.querySelector('product-form [name="id"]');
        var id = (input && input.value) || this.getAttribute('data-default-variant');
        var qty = this.currentQty();
        var code = (this.selected && this.selected.getAttribute('data-code')) || '';
        return { items: [{ id: Number(id), quantity: qty }], code: code, ok: !!id };
      }
      var data = parseJSON(this.querySelector('[data-kkb-mix]'), { items: [], code: '' });
      return {
        items: data.items.map(function (i) { return { id: Number(i.id), quantity: i.quantity || 1 }; }),
        code: data.code || '',
        ok: data.items.length > 0
      };
    }

    async onAdd(evt) {
      evt.preventDefault();
      if (this.errorEl) this.errorEl.textContent = '';
      var payload = this.getItems();
      if (!payload.ok || !payload.items.length || !payload.items[0].id) {
        if (this.errorEl) this.errorEl.textContent = this.ownVariants
          ? 'Bitte für jedes Teil Farbe und Größe wählen.'
          : 'Bitte zuerst eine Variante wählen.';
        return;
      }

      this.button.setAttribute('aria-busy', 'true');
      this.button.classList.add('loading');

      try {
        // 1) auto-apply the matching discount (silent) so cart/checkout shows the reduced price
        if (payload.code) {
          try {
            await fetch('/discount/' + encodeURIComponent(payload.code), {
              method: 'GET', redirect: 'follow', credentials: 'same-origin'
            });
          } catch (e) { /* non-fatal */ }
        }

        // 2) add the items to the AJAX cart, requesting cart sections for the drawer
        var body = { items: payload.items };
        if (this.cart && this.cart.getSectionsToRender) {
          body.sections = this.cart.getSectionsToRender().map(function (s) { return s.id; });
          body.sections_url = window.location.pathname;
        }

        var res = await fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
          body: JSON.stringify(body)
        });
        var json = await res.json();

        if (json.status) {
          if (this.errorEl) this.errorEl.textContent = json.description || 'Konnte nicht hinzugefügt werden.';
          return;
        }

        // 3) reflect in the drawer/notification (or fall back to the cart page)
        if (this.cart && this.cart.renderContents) {
          if (this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          this.cart.renderContents(json);
        } else {
          window.location = (window.routes && window.routes.cart_url) || '/cart';
        }
      } catch (e) {
        if (this.errorEl) this.errorEl.textContent = 'Etwas ist schiefgelaufen. Bitte erneut versuchen.';
      } finally {
        this.button.setAttribute('aria-busy', 'false');
        this.button.classList.remove('loading');
      }
    }
  }

  window.customElements.define('bundle-deals', BundleDeals);
})();
